const DURATION = 0.3;
// Easings
export const Easings = {
    easeIn: 'easeIn',
    easeOut: 'easeOut',
    linear: 'linear',
};
// Shorthands
export const transitionIn = {
    transition: {
        duration: DURATION,
        ease: Easings.easeOut,
    },
};
export const transitionOut = {
    transition: {
        duration: 0.1,
        ease: Easings.easeIn,
    },
};
export const noTransition = {
    transition: {
        duration: 0,
    },
};
